import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStore = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.786 3.84h12.428c.784 0 1.487.493 1.766 1.24l.894 2.601c.472 1.262-.442 2.613-1.766 2.613H4.892c-1.324 0-2.239-1.351-1.766-2.613L4.02 5.08c.28-.746.983-1.24 1.767-1.24M8.534 10.296 9.44 3.84M15.562 10.296l-.906-6.455M4.79 10.302v7.248a2.623 2.623 0 0 0 2.636 2.61h9.147a2.623 2.623 0 0 0 2.637-2.608v-7.257"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.537 20.16v-3.482a2.462 2.462 0 1 1 4.926 0v3.482"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStore);
export default ForwardRef;
